module.exports = __webpack_public_path__ + "static/media/room5.454c2f47.png";